<div class="send-kns-content">
  <div class="send-kns-form">
    <!-- Wallet Address Input -->
    <div class="form-field">
      <app-address-smart-input
        [label]="'Wallet Address'"
        [placeholder]="'Enter recipient wallet address or KNS domain'"
        [isFullWidth]="true"
        [isValid]="isAddressValid"
        [invalidReason]="addressErrorMessage"
        [isDisabled]="isLoading"
        [value]="walletAddress"
        (valueChange)="onWalletAddressChange($event)"
        (resolved)="onAddressResolved($event)"
        (qrClick)="onQrScanClick()"
      />
    </div>

    <!-- Replace By Fee Checkbox -->
    <div class="form-field">
      <app-checkbox-input
        [checked]="replaceByFee"
        [isDisabled]="isLoading"
        (checkedChange)="onRbfChange($event)"
      >
        Replace By Fee (RBF)
      </app-checkbox-input>
    </div>

    <!-- Send Button -->
    @if (isListed()) {
      <div class="listing-warning text-gray-60 typo-text-1">
        Cancel the listing before sending this domain.
      </div>
    }

    <div class="form-field">
      <kc-button
        [text]="isLoading ? 'Sending...' : 'Send Domain'"
        [variant]="'primary'"
        [isFullWidth]="true"
        [isLoading]="isLoading"
        [isDisabled]="!isFormValid"
        (buttonClick)="onSendClick()"
      />
    </div>
  </div>
</div>
